import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/EditOutlined";
import DoneIcon from "@material-ui/icons/DoneAllTwoTone";
import RevertIcon from "@material-ui/icons/NotInterestedOutlined";
import { TextField } from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import parse from "html-react-parser";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  }
}));

const CustomTableCell = ({ row, name, onChange, lp, isHtml }) => {
  const classes = useStyles();
  const { isEditMode } = row;
  return (
    <TableCell align="left" className={classes.tableCell}>
      {isEditMode && onChange ? (
        <TextField
          value={row[name]}
          name={name}
          onChange={(e) => onChange(e, row)}
          className={classes.input}
          fullWidth
        />
      ) : lp ? (
        lp
      ) : isHtml ? (
        parse(row[name])
      ) : (
        row[name]
      )}
    </TableCell>
  );
};

function KmFormEditTable({ columns, rows, caption, setRows, editable, ...rest }) {
  const [previous, setPrevious] = React.useState({});
  const classes = useStyles();
  const editableTab = (editable !== null) ? editable : true;

  const onToggleEditMode = (id) => {
    setRows((state) => {
      return rows.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };

  const onDelete = (id) => {
    setRows(rows.filter((row) => row.id !== id));
  };

  const onChange = (e, row) => {
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return { ...row, [name]: value };
      }
      return row;
    });
    setRows(newRows);
  };

  const onRevert = (id) => {
    const newRows = rows.map((row) => {
      if (row.id === id) {
        return previous[id] ? previous[id] : row;
      }
      return row;
    });
    setRows(newRows);
    setPrevious((state) => {
      delete state[id];
      return state;
    });
    onToggleEditMode(id);
  };

  return (
    <Table className={classes.table} aria-label="caption table">
      {caption ? <caption>{caption}</caption> : <></>}
      <TableHead>
        <TableRow>
          {columns.map((cell) => (
            <TableCell width={cell.width} align="left">
              {cell.label}
            </TableCell>
          ))}
          <TableCell component="td" width="5%" align="left" />
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, index) => (
          <TableRow key={row.id}>
            {columns.map((cell) => (
              <CustomTableCell
                {...{
                  row,
                  name: cell.fieldName,
                  onChange: cell.isEditable ? onChange : null,
                  lp: cell.isLp ? index + 1 : null,
                  isHtml : cell.isHtml
                }}
              />
            ))}
            <TableCell className={classes.selectTableCell}>
              {row.isEditMode ? (
                <>
                  <IconButton
                    aria-label="done"
                    onClick={() => onToggleEditMode(row.id)}
                  >
                    <DoneIcon />
                  </IconButton>
                  <IconButton
                    aria-label="revert"
                    onClick={() => onRevert(row.id)}
                  >
                    <RevertIcon />
                  </IconButton>
                </>
              ) : (
                <>
                  { editableTab ? <IconButton
                    aria-label="edit"
                    onClick={() => onToggleEditMode(row.id)}
                  >
                    <EditIcon />
                  </IconButton> : <></> }
                  {!row.noDelete ? <IconButton
                    aria-label="delete"
                    onClick={() => onDelete(row.id)}
                  >
                    <DeleteOutlineIcon />
                  </IconButton> : <></>}
                </>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default KmFormEditTable;
